import {
  Select,
  Form,
  Input,
} from "antd";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import "./index.less";
import TokenModal from "./components/TokenModal";
import { useTokenDetails } from "@/hooks/useTokenDetails";
import { useTranslation } from "react-i18next";
import { getSymbol } from "@/config/symbol";
import { DEFAULT_RPC, NET_NAME } from "@/config";
import { cdnUrl } from "@/utils/cdn";
import { message } from "antd";
import { SuiClient, getFullnodeUrl } from "@mysten/sui/client";
import { isValidCoinType } from "@/utils/suiMethods";

type TokenItem = {
  coinType: string;
  totalBalance: string; // 最小单位字符串
  symbol: string;
  decimals: number;
  name: string;
  iconUrl: string;
  tokenType: string;
};
const client = new SuiClient({
  url: DEFAULT_RPC,
});
const nativeCoin: any = {
  "sui": "0x2::sui::SUI"
};
const stableTokens = {
  "usdc": "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC",
  "usdt": "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT",
}
// let storageLists: any[] = [];
/**
 * A component that renders a selectable dropdown list with images and token information.
 *
 * @param {any} props - The component props.
 * @param {Array} props.filterAddrs - Optional list of addresses to filter out from the dropdown options.
 * @param {string} props.placeholder - Placeholder text for the dropdown input.
 *
 * @param {Function} props.onSearchInput - Callback function to handle search input changes. 没人用这个参数
 * @param {boolean} [props.isShort=false] - Flag to determine if addresses should be shortened.
 * @param {boolean} [props.disabled=false] - Flag to disable the dropdown input.
 * @param {string} [props.listType="all"] - Type of token list to retrieve, options are "all", "stableAndNative", or "other".
 * @param {Function} props.getSelectedTokenInfo - Callback function to get information of the selected token.
 * @param {Object} restProps - Additional properties for the Select component.
 *
 * @returns {JSX.Element} A component that displays a dropdown with token options.
 */

const ListModalAntd = forwardRef(
  (
    {
      filterAddrs,
      placeholder = "",
      inputDisabled = false,
      disabled = false,
      getSelectedTokenInfo,
      customkenCoinTypeLists,
      address,
      searchPlaceholder = "",
      canClear = true,
      value,
    }: any,
    ref
  ) => {

    const { t } = useTranslation();
    const [storageLists, setStorageLists] = useState<any[]>([]);
    const [mintSearching, setMintSearching] = useState(false);
    const [list, setList] = useState<any>([]);
    const [currentDetail, setCurrentDetail] = useState({
      coinType: "",
      decimals: 0,
      iconUrl: "",
      name: "",
      symbol: "",
      tokenType: "",
      totalBalance: ""
    });
    // console.log("currentDetail", currentDetail, value)
    const clearInput = () => {
      // console.log("clearrrrr");
      setCurrentDetail({
        coinType: "",
        decimals: 0,
        iconUrl: "",
        name: "",
        symbol: "",
        tokenType: "",
        totalBalance: ""
      });
      // getSelectedTokenInfo && getSelectedTokenInfo(undefined);
      return undefined;
    };

    async function mapLimit<T, R>(
      arr: T[],
      limit: number,
      fn: (x: T, i: number) => Promise<R>
    ): Promise<R[]> {
      // console.log("arr", arr)
      const ret: R[] = [];
      let i = 0;
      const workers = Array.from({ length: Math.min(limit, arr.length) }, async () => {
        while (i < arr.length) {
          const cur = i++;
          ret[cur] = await fn(arr[cur], cur);
        }
      });
      // console.log("workers", workers)
      // console.log("ret", ret)
      await Promise.all(workers);
      return ret;
    }
    async function getUserTokensWithMeta(owner: string) {
      const balances = await client.getAllBalances({ owner });
      const enriched = await mapLimit(balances, 30, async (b) => {
        const meta = await client.getCoinMetadata({ coinType: b.coinType }).catch(() => null);
        return {
          coinType: b.coinType,
          totalBalance: b.totalBalance, // 最小单位字符串
          symbol: meta?.symbol ?? "",
          decimals: meta?.decimals ?? 0,
          name: meta?.name ?? "",
          iconUrl: meta?.iconUrl ?? "",
          tokenType: "user"
        };
      });
      // console.log("enriched", enriched)
      return enriched;
    }

    async function fetchOneToken(
      client: SuiClient,
      coinType: string,
      address?: string,
      tokenType?: string
    ): Promise<TokenItem> {
      // console.log("coinTypecoinTypecoinType", coinType)
      const [meta, bal] = await Promise.all([
        client.getCoinMetadata({ coinType }).catch(() => null),
        address
          ? client
            .getBalance({ owner: address, coinType })
            .then((r) => r?.totalBalance ?? "0")
            .catch(() => "0")
          : Promise.resolve("0"),
      ]);
      // console.log("查询到的meta", meta)
      return {
        coinType,
        totalBalance: bal,
        symbol: meta?.symbol ?? "",
        decimals: typeof meta?.decimals === "number" ? meta.decimals : 0,
        name: meta?.name ?? "",
        iconUrl: meta?.iconUrl ?? "",
        tokenType: tokenType || "official"
      };
    }

    async function getPresetTokens(
      client: SuiClient,
      address?: string
    ): Promise<TokenItem[]> {
      const tasks: Promise<TokenItem>[] = [
        fetchOneToken(client, nativeCoin.sui, address),
        fetchOneToken(client, stableTokens.usdc, address),
        fetchOneToken(client, stableTokens.usdt, address),
      ];

      // 三个币并发
      return Promise.all(tasks);
    }

    async function getTokens() {
      try {
        nativeCoin.address = getSymbol();
        let tmp = [];
        let userTokens: any = [];
        let customTokens: any = [];
        const nativeAndStable = await getPresetTokens(client, address)
        // console.log("res222", nativeAndStable)
        if (address) {
          userTokens = await getUserTokensWithMeta(address);
          customTokens = customkenCoinTypeLists && await queryCustomCoins(customkenCoinTypeLists);
          // console.log("userTokens", userTokens)
          // console.log("customTokens", customTokens)
        }
        if (customkenCoinTypeLists && customkenCoinTypeLists.length > 0) {
          tmp = [...customTokens]
        } else {
          tmp = [...nativeAndStable, ...userTokens];
        }
        // 2) 过滤：只要 item.address 或 item.coinType 命中 filterAddrs 任意一个，就剔除
        if (filterAddrs && filterAddrs?.length > 0) {
          const ban = new Set(filterAddrs.map((x: string) => (x || "").trim().toLowerCase()));
          tmp = tmp.filter((item: any) => {
            const coinType = (item.coinType || "").toString().trim().toLowerCase();
            return !ban.has(coinType);
          });
        }
        const seen = new Set<string>();
        tmp = tmp.filter((item: any) => {
          const key = (item.coinType || "").toString().trim().toLowerCase();
          if (!key) return true;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        setStorageLists(tmp);
        setList(tmp);
      } catch (error) {
        // 处理错误
      }
    }

    useEffect(() => {
      getTokens()
    }, [address, filterAddrs, customkenCoinTypeLists])

    useEffect(() => {
      const getValue = async () => {
        const values = await fetchOneToken(client, value, address);
        setCurrentDetail({ ...values })
      }
      getValue()
    }, [value, address])
    // 1) currentDetail 变了就通知父组件（统一出口）
    useEffect(() => {
      // 如果你不想一开始空对象就触发，可以加判断
      const hasValue = !!currentDetail?.coinType;
      if (!hasValue) {
        getSelectedTokenInfo?.(undefined);
        return;
      }
      getSelectedTokenInfo?.(currentDetail);
    }, [currentDetail]);
    // const queryCustomCoins = async (coinTypes: any) => {
    //   console.log("开始查询coinTypes")
    //   if (coinTypes) {
    //     const customTokensRes = await Promise.all(coinTypes.map(async (coinType: any) => {
    //       const metadata = await client.getCoinMetadata({ coinType });
    //       console.log("自定义的cointypes", metadata)
    //       let totalBalance = "0";
    //       if (address) {
    //         const res = await client.getBalance({
    //           owner: address,
    //           coinType
    //         })
    //         console.log("自定义代币的余额", res);
    //         totalBalance = res.totalBalance
    //       }
    //       return {
    //         ...metadata,
    //         totalBalance,
    //         coinType
    //       }
    //     }))

    //     return customTokensRes;
    //   } else {
    //     return []
    //   }
    // }
    const queryCustomCoins = async (coinTypes: string[]) => {
      if (!coinTypes?.length) return [];

      const settled = await Promise.allSettled(
        coinTypes.map(async (coinType) => {
          const [meta, bal] = await Promise.all([
            client.getCoinMetadata({ coinType }),             // 不 catch，让它 reject
            address ? client.getBalance({ owner: address, coinType }) : null,
          ]);

          return {
            coinType,
            totalBalance: address ? (bal as any)?.totalBalance ?? "0" : "0",
            symbol: meta?.symbol ?? "",
            decimals: meta?.decimals ?? 0,
            name: meta?.name ?? "",
            iconUrl: meta?.iconUrl ?? "",
            tokenType: "user",
          };
        })
      );

      return settled
        .filter((x): x is PromiseFulfilledResult<any> => x.status === "fulfilled")
        .map((x) => x.value);
    };

    const inputChange = async (value: any) => {
      // console.log("inputChange", value)
      if (customkenCoinTypeLists && customkenCoinTypeLists.length > 0 || !isValidCoinType(value)) {
        setList([])
        return
      }
      const ban = new Set((filterAddrs || []).map((x: string) => (x || "").trim().toLowerCase()));
      if (ban.has(value.toLowerCase())) {
        // console.log("该代币已被过滤")
        setList([])
        return;
      }
      //查询
      setMintSearching(true)
      const values = await fetchOneToken(client, value, address, "search");
      if (!values.symbol) {
        setList([])
        setMintSearching(false)
        return
      }
      setList([values])
      setMintSearching(false)
      // console.log("mint新的token", values)
    }
    return (
      <>
        <Form.Item
          rules={[{ required: true, message: t("ListModalAntd.selectToken") }]}
        >
          <div>
            <Input type="hidden" />
            <TokenModal
              disabled={disabled}
              currentDetail={currentDetail}
              canClear={canClear}
              setCurrentDetail={setCurrentDetail}
              placeholder={placeholder}
              getTokens={getTokens}
              inputDisabled={inputDisabled}
              searchPlaceholder={searchPlaceholder}
              inputChange={inputChange}
              getSelectedTokenInfo={getSelectedTokenInfo}
              mintSearching={mintSearching}
              list={list}
              setList={setList}
              storageLists={storageLists}
              clearInput={clearInput}
            // handleRefreshClick={handleRefreshClick}
            ></TokenModal>
          </div>
        </Form.Item>
      </>
    );
  }
);
export default ListModalAntd;
